var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('AppHeader',_vm._b({},'AppHeader',_vm.props,false)),_c('div',{attrs:{"id":"ot-sdk-cookie-policy"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }